module.exports = require("./lg.d.ts");